import { Component } from '@angular/core';

@Component({
  selector: 'app-add-generic-step',
  standalone: false,
  templateUrl: './add-generic-step.component.html',
  styleUrl: './add-generic-step.component.scss'
})
export class AddGenericStepComponent {

}
